import { PedagogicalFieldGroup } from '@api';

/** Mirrors backend `SystemPedagogicalFields` (KT-660 C3). */
export const PEDAGOGICAL_FIELD_CONTENT_GOAL = 'contentGoal';
export const PEDAGOGICAL_FIELD_CONTENT_GOAL_WAIVED = 'contentGoalWaived';

export const SYSTEM_PEDAGOGICAL_FIELD_NAMES: ReadonlySet<string> = new Set([
  'competenciesAndConnections',
  'essentialQuestion',
  'knowledgeType',
  'lessonPlan',
  PEDAGOGICAL_FIELD_CONTENT_GOAL,
  PEDAGOGICAL_FIELD_CONTENT_GOAL_WAIVED,
  'prerequisiteKnowledge',
  'successCriteria',
  'supportLevel',
  'teacherNoteAfter',
  'teacherNoteBefore',
  'teacherNoteDuring',
  'thinkingGoal',
]);

/**
 *
 * @param fieldName
 */
export function pedagogicalFieldGroupOf(
  fieldName: string,
): (typeof PedagogicalFieldGroup)[keyof typeof PedagogicalFieldGroup] {
  return SYSTEM_PEDAGOGICAL_FIELD_NAMES.has(fieldName) ? PedagogicalFieldGroup.SYSTEM : PedagogicalFieldGroup.EXTRA;
}

/**
 *
 * @param fieldName
 */
export function pedagogicalFieldPairPartner(fieldName: string): string | null {
  if (fieldName === PEDAGOGICAL_FIELD_CONTENT_GOAL) {
    return PEDAGOGICAL_FIELD_CONTENT_GOAL_WAIVED;
  }
  if (fieldName === PEDAGOGICAL_FIELD_CONTENT_GOAL_WAIVED) {
    return PEDAGOGICAL_FIELD_CONTENT_GOAL;
  }
  return null;
}

export const PEDAGOGICAL_MENU_I18N_PREFIX = 'DETAIL.EDIT_PAGE.PEDAGOGICAL.FIELDS';
export const PEDAGOGICAL_OPTION_I18N_PREFIX = 'DETAIL.EDIT_PAGE.PEDAGOGICAL.OPTIONS';
export const PEDAGOGICAL_SELECT_PLACEHOLDER_KEY = 'DETAIL.EDIT_PAGE.PEDAGOGICAL.SELECT_PLACEHOLDER';

/** Debounce before a lesson plan (Óraterv) HTML edit is saved. Matches the sections editor pause. */
export const PEDAGOGICAL_HTML_COMMIT_DELAY_MS = 500;

/**
 *
 * @param fieldName
 */
export function pedagogicalMenuLabelKey(fieldName: string): string {
  return `${PEDAGOGICAL_MENU_I18N_PREFIX}.${fieldName}`;
}

/**
 *
 * @param optionCode
 */
export function pedagogicalOptionLabelKey(optionCode: string): string {
  return `${PEDAGOGICAL_OPTION_I18N_PREFIX}.${optionCode}`;
}
